module.exports = __webpack_public_path__ + "static/media/line.088341e9.svg";